import { t } from 'i18next';
import { DrawController } from 'src/controllers';

export const headerDrawGroupTitles = () => ({
  show: t('hymotsc.drawTool.layerDetails'),
  create: t('hymotsc.drawTool.addLayer'),
  edit: t('hymotsc.drawTool.editLayer'),
});

export interface IProps {
  active: boolean | undefined;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
  tarafId: number | undefined;
  drawController: DrawController | undefined;
}

export enum LocalFormDisplayMode {
  SHOW,
  CREATE,
  EDIT,
  HIDE,
}
